import React, { useEffect, useState } from 'react'
import useMakeRequest from '../utils/ApiHelper'
import { ApiConstants } from '../constants/ApiConstants'
import { useNavigate } from 'react-router-dom'
import FrontLoader from '../component/layout/FrontLoader'
import { LanguageConstants } from '../constants/LanguageConstants'

function QuotationEditMessage(props:any) {
   const  QuotationUpdate = useMakeRequest()
   const navigate = useNavigate()
    
const editModalOpen =()=>{
   const payload ={
    quotes:props?.quotes,
    quotation_id:props?.data?.quotation_id,
    address_id:props?.data?.address_id
   } 
    QuotationUpdate.makeRequest({payload, url: ApiConstants?.QuotesUpdate, toastStatus: true }) 
}

useEffect(()=>{
if(QuotationUpdate?.status){
    navigate('/my-quotation')
    props.handleClose()
}
},[QuotationUpdate?.status])


  return (
    <>
    {QuotationUpdate?.loading ? <FrontLoader/> : null}
    <div className="modal fade com-modal short-modal show" id="editMessageProductModal" aria-labelledby="editMessageProductModalLabel" aria-hidden="false"  style={{display: "block"}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="editMessageProductModalLabel">{LanguageConstants?.Edit_Quantity}</h5>
                            <button onClick={()=>props.handleClose()}  type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                        </div>
                        <div className="modal-body pb-0 text-start">
                            <p className="modal-para mt-2">{LanguageConstants?.EDIT_Q_MESSAGE}</p>
                        </div>
                        <div className="modal-footer">
                            <div className="row w-100">
                                <div className="col-6 ps-0">
                                    <button onClick={()=>props.handleClose()} type="submit" className="round-btn round-btn-gray m-0 w-100" >{LanguageConstants?.CANCEL}</button>
                                </div>
                                <div className="col-6 pe-0">
                                    <button type="submit" className="round-btn m-0 w-100" onClick={()=>editModalOpen()}  >{LanguageConstants?.EDIT}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    </div>
    </>
  )
}

export default QuotationEditMessage